import React, {useRef} from "react";
import { FaEllipsisV, FaRegClock, FaSlash } from "react-icons/fa";
import { Row, Col, Card, Button, Image, Badge, Form, Modal, Spinner, Alert } from "react-bootstrap";
import { MdOutlinePrecisionManufacturing } from "react-icons/md";
import { VscNewFile } from "react-icons/vsc";
import apiEndPoints from "../../../../componets/json/apiEndPoints.json"

class Vendors extends React.Component {
    state = {
        vendors: [],
        filterValue: "",
        loading: {
            text: "Úprava vlastností výrobce",
            status: false,
            variant: "info"
        },
        modalShow: false,
        modalId: null
    }

    changeItem = (e) => {
        let vendors = this.state.vendors;
        let i = 0;
        vendors.forEach(v => {
            if (v.id == this.state.modalId) {
                if (e.target.id == "isWebAuthorize") vendors[i] = { ...vendors[i], isWebAuthorize: e.target.checked }
                if (e.target.id == "isWebPriceListAllow") vendors[i] = { ...vendors[i], isWebPriceListAllow: e.target.checked }
                if (e.target.id == "isWebReqAllow") vendors[i] = { ...vendors[i], isWebReqAllow: e.target.checked }
                if (e.target.id == "isWebShow") vendors[i] = { ...vendors[i], isWebShow: e.target.checked }
                if (e.target.id == "webCardText") vendors[i] = { ...vendors[i], webCardText: e.target.value }
            }
            i++;
        })
        this.setState({ vendors: vendors });
        this.apiChange(this.state.modalId);
    }

    filterFunc = (data) => {
        let filterData = data;
        if (filterData) {
            if (this.state.filterValue.length > 0) {
                const fulltext = JSON.stringify(filterData);
                return fulltext.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) > -1
            } else {
                return filterData;
            }

        }
    }

    toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    uploadFile = async (file) => {
        let base64 = await this.toBase64(file.target.files[0]).then(f => {
            return f
        });
        let vendors = this.state.vendors;
        let i = 0;
        vendors.forEach(v => {
            if (v.id == this.state.modalId) {
                 vendors[i] = { ...vendors[i], webImgLogo: base64 }
            }
            i++;
        })
        this.setState({ vendors: vendors });
        this.apiChange();
    }

    apiChange = async (id) => {
        this.setState({ loading: { ...this.state.loading, status: true } });
        const _res = await this.props._api({
            ...this.props,
            method: "post",
            data: this.props._encrypt(JSON.stringify(this.state.vendors.filter(f => f.id == this.state.modalId)[0])),
            endpoint: apiEndPoints.britex.Admin.change.vendor,
            param: "",
        });
        this.setState({ loading: { ...this.state.loading, status: false } });
        if (_res.status == 200) {
        }
    }

    getVendors = async () => {
        this.setState({ loading: { ...this.state.loading, status: true } });
        const _res = await this.props._api({
            ...this.props,
            method: "get",
            endpoint: apiEndPoints.britex.LookUpValue.vendors_v2,
            param: "",
        });
        this.setState({ loading: { ...this.state.loading, status: false } });
        if (_res.status == 200) {
            this.setState({ vendors: JSON.parse(this.props._decrypt(_res.data)) });
        }
    }

    handleClick(e) {
        this.inputFile.current.click();
    }

    componentDidMount() {
        this.props.setHeaderPage({
            Icon: <MdOutlinePrecisionManufacturing className="c-placeholder c-green" />,
            Title: "Výrobce",
            SubTitle: "",
        });

        this.getVendors();
    }

    render() {
        const { _placeholder } = this.props;
        const _h = React.createElement(_placeholder);
        return (
            <>
                {this.state.modalShow && (
                    <Modal
                        show={this.state.modalShow}
                        onHide={() => this.setState({ modalShow: false })}
                        centered
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        backdrop="static"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <span className="h5">{this.state.modalId ? this.state.vendors.filter(f => f.id == this.state.modalId)[0].FirmName : <Form.Control placeholder="Název výrobce" />}</span>
                            </Modal.Title>
                        </Modal.Header>
                        <Alert variant={this.state.loading.variant}>
                            <Row>
                                <Col className="d-flex justify-content-between">
                                    {this.state.loading.text}
                                    {this.state.loading.status && (
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    )}
                                </Col>
                            </Row>
                        </Alert>
                        <Modal.Body>
                            <Row className="mb-4">
                                <Col className="d-flex align-items-center justify-content-center">
                                    <div className="add-media" onClick={() => document.getElementById("file").click()}>
                                        <Image data-tip="Změnit logo" src={this.state.vendors?.filter(f => f.id == this.state.modalId)[0].webImgLogo
                                            ? this.state.vendors.filter(f => f.id == this.state.modalId)[0].webImgLogo :
                                            this.props._defaultImg} className="img-fluid cursor-pointer" width={50} />
                                        <input type="file" id="file" 
                                        onChange={this.uploadFile}
                                        style={{ display: "none" }} />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="d-flex align-items-center">
                                    <Form.Switch
                                        checked={
                                            this.state.vendors?.filter(f => f.id == this.state.modalId)[0].isWebReqAllow
                                        }
                                        id="isWebReqAllow"
                                        onChange={this.changeItem}
                                    /><Form.Text>Web požadavky na opravu</Form.Text>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="d-flex align-items-center">
                                    <Form.Switch
                                        checked={
                                            this.state.vendors?.filter(f => f.id == this.state.modalId)[0].isWebShow
                                        }
                                        id="isWebShow"
                                        onChange={this.changeItem}
                                    /><Form.Text>Web databáze oprav</Form.Text>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={12} className="d-flex align-items-center">
                                    <Form.Switch checked={
                                        this.state.vendors?.filter(f => f.id == this.state.modalId)[0].isWebAuthorize
                                    }
                                        id="isWebAuthorize"
                                        onChange={this.changeItem}
                                    /><Form.Text>Web autorizace</Form.Text>
                                </Col>
                                {this.state.vendors?.filter(f => f.id == this.state.modalId)[0].isWebAuthorize && (
                                    <Col xs={12} className="mt-2">
                                        <Form.Control as="textarea" rows={6}
                                            value={
                                                this.state.vendors?.filter(f => f.id == this.state.modalId)[0].webCardText
                                            }
                                            id="webCardText"
                                            onChange={this.changeItem}
                                        />
                                        <Form.Text>Web autorizace popis</Form.Text>
                                    </Col>
                                )}
                            </Row>
                            <Row className="mb-2">
                                <Col className="d-flex align-items-center">
                                    <Form.Switch
                                        checked={
                                            this.state.vendors?.filter(f => f.id == this.state.modalId)[0].isWebPriceListAllow
                                        }
                                        id="isWebPriceListAllow"
                                        onChange={this.changeItem}
                                    /><Form.Text>Web ceníky</Form.Text>
                                </Col>
                            </Row>
                        </Modal.Body>
                    </Modal>
                )}


                <Row className="mt-4 mb-4">
                    <Card bg="uni">
                        <Card.Body>
                            <Col xs={12} className="d-flex justify-content-between align-items-center">
                                <span><strong>Parametry</strong></span>
                                <VscNewFile className="fs-20 cursor-pointer c-gray" data-tip="Nový výrobce"
                                    onClick={() => this.setState({ modalShow: true, modalId: null })} />
                                <Col xs={3}>
                                    <Form.Control
                                        placeholder="...filtrovat"
                                        value={this.state.filterValue}
                                        onChange={(e) => this.setState({ filterValue: e.target.value })} />
                                </Col>
                            </Col>
                        </Card.Body>
                    </Card>

                </Row>


                <Row>
                    <Col>
                        {this.state.vendors.filter(this.filterFunc).map((e, idx) => (
                            <Card className="mb-2">
                                <Card.Body>
                                    <Row>
                                        <Col className="d-flex justify-content-between align-items-center">
                                            <Image src={e.webImgLogo ? e.webImgLogo : this.props._defaultImg} className="img-fluid" width={50} />
                                            <span><strong>{e.FirmName}</strong></span>
                                            <FaEllipsisV
                                                className="fs-20 cursor-pointer c-gray"
                                                data-tip="Možnosti"
                                                onClick={() => this.setState({ modalShow: true, modalId: e.id })} />
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        ))}
                    </Col>
                </Row>
            </>
        );
    }
}

export default Vendors;
